/* eslint-disable @angular-eslint/directive-selector */
import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[rightClick]',
  standalone: true 
})
export class RightClickDirective {
  @Output() rightClick = new EventEmitter<MouseEvent>();

  // Listen for the 'contextmenu' event directly on the host element.
  @HostListener('contextmenu', ['$event'])
  onRightClick(event: MouseEvent): void {
    // Prevent the default browser menu
    event.preventDefault();

    // Emit the custom output event
    this.rightClick.emit(event);
  }
}